import { render, staticRenderFns } from "./EmailExtension.vue?vue&type=template&id=1f6e693f&scoped=true"
import script from "./EmailExtension.vue?vue&type=script&lang=js"
export * from "./EmailExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e693f",
  null
  
)

export default component.exports